import Icon, { iconColor, iconTypes } from "./Icon.jsx";

import { Localization } from "../util/localization.jsx";
import Modal from "../components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";

class YesNoModal extends React.PureComponent {
    render(){
        const {
            localization,
            onCloseModal,
            label,
            label2,
            labelHeader,
            headerColor,
            onYes,
            onNo,
            onCancel,
        } = this.props;
        return (
            <Modal onCloseModal={onCloseModal}>
                <div className="modal-wrapper">
                    <div className="header bottom-border">
                        <div className="header-left">
                            <div className="header-detail" style={{color:headerColor}}>{labelHeader}</div>
                        </div>
                        <button className="btn circular" style={{float:"right"}} onClick={onCloseModal}>
                            <Icon type={iconTypes.x} color={iconColor.red}/>
                        </button>
                    </div>
                    <div className="body">
                        {label}
                    </div>
                    {label2!=null && (
                        <div className="body">
                            {label2}
                        </div>
                    )}
                    <div className="footer">
                        {onCancel && (
                            <button className="btn" style={{float:"right", marginLeft:"8px"}} onClick={onCancel}>
                                {localization.text("common","cancel")}
                            </button>
                        )}
                        {onNo && (
                            <button className="btn" style={{float:"right", marginLeft:"8px"}} onClick={onNo}>
                                {localization.text("common","no")}
                            </button>
                        )}
                        {onYes && (
                            <button className="btn" style={{float:"left"}} onClick={onYes}>
                                {localization.text("common","yes")}
                            </button>
                        )}
                    </div>
                </div>
            </Modal>
        );
    }
}
YesNoModal.propTypes = {
    localization: Localization.propTypes.isRequired,
    label: PropTypes.string.isRequired,
    label2: PropTypes.string.isRequired,
    labelHeader: PropTypes.string.isRequired,
    headerColor: PropTypes.string,
    onYes: PropTypes.func,
    onNo: PropTypes.func,
    onCancel: PropTypes.func,
    onCloseModal: PropTypes.func.isRequired,
};
YesNoModal.deafaultProps = {
    headerColor: "#e63332",
};

export default  YesNoModal;